export default __webpack_public_path__ + "static/media/hamburger.d19dbc4a.svg";